import { Component, ElementRef, inject } from '@angular/core';
import type { FocusableOption } from '@angular/cdk/a11y';

@Component({
  templateUrl: './date-picker-button.component.html',
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'button [tdWbDatePickerButton]',
  styleUrls: ['./date-picker-button.component.scss']
})
export class DatePickerButtonComponent implements FocusableOption {
  private readonly elementRef: ElementRef<HTMLElement> = inject<ElementRef<HTMLElement>>(ElementRef);

  focus(): void {
    this.elementRef.nativeElement.focus();
  }
}
